// extracted by mini-css-extract-plugin
export default {"header":"AMLCheckDetails_header__WoFLX","edit":"AMLCheckDetails_edit__y0ZJS","vote":"AMLCheckDetails_vote__fxWOo"};